interface FilterOption {
  label: string;
  value: string;
}

interface FilterGroupProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="shrink-0 text-sm text-foreground-500 sm:w-16 sm:pt-1">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
              value === opt
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

interface SortBarProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export function SortBar({ options, value, onChange }: SortBarProps) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-sm text-foreground-500 mr-1 hidden sm:inline">排序</span>
      <div className="flex items-center bg-background-100 rounded-full px-1 py-1">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer ${
              value === opt.value
                ? "bg-accent-500 text-primary-950 font-medium"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}